import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader.service';

@Component({
  selector: 'mini-loader',
  templateUrl: './mini-loader.component.html',
  styleUrls: ['./mini-loader.component.scss']
})
export class MiniLoaderComponent implements OnInit {

  constructor(private loader: LoaderService) { }
  showLoader = this.loader.showLoader;
  ngOnInit(): void {
  }

}
